import { render, staticRenderFns } from "./GuidedTourList.vue?vue&type=template&id=19b95d40&scoped=true&"
import script from "./GuidedTourList.vue?vue&type=script&lang=js&"
export * from "./GuidedTourList.vue?vue&type=script&lang=js&"
import style0 from "./GuidedTourList.vue?vue&type=style&index=0&id=19b95d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b95d40",
  null
  
)

export default component.exports